import { type HiringIncentiveProgram } from "@src/appV2/FeatureFlags/CbhFeatureFlags";
import { useMemo } from "react";

import { CbhFeatureFlag, useCbhFlag } from "../../FeatureFlags";
import { INCENTIVE_PROGRAM } from "./api/useGetIncentives";

export function useHiringIncentiveProgram() {
  const hiringIncentiveProgram = useCbhFlag(CbhFeatureFlag.HIRING_INCENTIVE_PROGRAM, {
    defaultValue: { enabled: false },
  });

  const isSignOnBonus = (
    data: HiringIncentiveProgram
  ): data is Extract<HiringIncentiveProgram, { type: "SIGN_ON_BONUS" }> => {
    return data.enabled && data.type === "SIGN_ON_BONUS";
  };

  const isCarePackage = (
    data: HiringIncentiveProgram
  ): data is Extract<HiringIncentiveProgram, { type: "CARE_PACKAGE" }> => {
    return data.enabled && data.type === "CARE_PACKAGE";
  };

  const incentiveProgram = useMemo(() => {
    if (isSignOnBonus(hiringIncentiveProgram)) {
      return INCENTIVE_PROGRAM.placementSignOnBonus;
    }

    if (isCarePackage(hiringIncentiveProgram)) {
      return INCENTIVE_PROGRAM.placementCarePackage;
    }

    return undefined;
  }, [hiringIncentiveProgram]);

  return {
    hiringIncentiveProgram,
    incentiveProgram,
    isSignOnBonus,
    isCarePackage,
  };
}
